import api from './client';

// Phase 52 · Admin CRUD for creator price options.

export const listCreatorPriceOptions = async () => {
  const res = await api.get('/admin/creator-price-options');
  return Array.isArray(res.data) ? res.data : [];
};

export const publicCreatorPriceOptions = async (scope) => {
  const params = scope ? { scope } : {};
  const res = await api.get('/config/creator-price-options', { params });
  return Array.isArray(res.data) ? res.data : [];
};

export const createCreatorPriceOption = async (payload) => {
  const res = await api.post('/admin/creator-price-options', payload);
  return res.data;
};

export const updateCreatorPriceOption = async (id, patch) => {
  const res = await api.patch(`/admin/creator-price-options/${id}`, patch);
  return res.data;
};

export const deleteCreatorPriceOption = async (id) => {
  const res = await api.delete(`/admin/creator-price-options/${id}`);
  return res.data;
};

export const reorderCreatorPriceOptions = async (ids) => {
  const res = await api.post('/admin/creator-price-options/reorder', { ids });
  return res.data;
};

export const getO2OPriceLimit = async () => {
  const res = await api.get('/admin/creator-price-options/o2o-limit');
  return res.data;
};

export const updateO2OPriceLimit = async (maxCredits) => {
  const res = await api.patch('/admin/creator-price-options/o2o-limit', { max_credits: maxCredits });
  return res.data;
};
